import { AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TreeNode } from 'src/app/core/tree/tree.interface';
import { LoginResponse } from 'src/app/model/response/auth-r';
import { UserDataString } from 'src/app/model/user';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LoginService } from '../login/login.service';
import { SideBarService } from './sidebar.service';
import { Subject, take, takeUntil } from 'rxjs';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { GlobalService } from 'src/app/services/global.service';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { fadeInOutWithBlur, slideDownUp, slideDownUpFastLeave, springEaseIn500ms } from 'src/app/core/global-app-animations';
import { ModuleBaseResponse } from 'src/app/model/response/modules/modules-menu';
import { User } from '../login/login';
import { UserService } from '../user/user.service';
import { AppTreeModules } from 'src/app/model/global-interface';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    slideDownUp,
    slideDownUpFastLeave,
    trigger('expandCollapseSidebar', [
      state('false', style({ 'width': '300px', transform: 'translateX(0)' })),
      state('true', style({ 'width': '*' })),
      transition('false => true', animate(springEaseIn500ms)),
      transition('true => false', animate(springEaseIn500ms))
    ]),
    trigger('showSidebar', [
      state('false', style({ 'opacity': '1', })),
      state('true', style({ 'opacity': '0', })),
      transition('false => true', animate(springEaseIn500ms)),
      transition('true => false', animate(springEaseIn500ms))
    ]),
    trigger('expandCollapseSidebarLogo', [
      state('false', style({ 'max-heigth': '15%' })),
      state('true', style({ 'max-heigth': '15%' })),
      transition('false => true', animate(springEaseIn500ms)),
      transition('true => false', animate(springEaseIn500ms))
    ]),
    fadeInOutWithBlur
  ],
  standalone: false
})

export class SidebarComponent implements OnInit, OnDestroy, AfterViewInit {
  ver: string = environment.version;

  @Input() expanded: boolean = false;

  private theEnd$ = new Subject<void>();

  data: TreeNode[] =  AppTreeModules;

  logoPath: string = `${environment.baseHREF}${environment.logo}`;

  displayOptions: boolean = false;

  isMobile: boolean = false;

  ready: boolean = false;

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  user?: User;

  @HostListener('window:resize', ['$event'])
  onWindowResize() {

    if (window.innerHeight > window.innerWidth) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  constructor(
    private loginService: LoginService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private sideBarService: SideBarService,
    private browserDetector: BrowserDetectorService,
    private globalService: GlobalService,
    private userService:UserService
  ) {

    this.isMobile = browserDetector.detectBrowserMobile();
  }


  ngOnInit(): void {
    this.userService.getCurrentUserProfile().pipe(take(1)).subscribe({
      next:(response:User) =>{
        this.user = response;
      }
    })
    //get the menu from localStorage, if the menu is not there retry after 
    /*     let item = localStorage.getItem('M') || ''
        if (item == '') {
          setTimeout(() => {
            let menu = JSON.parse(this.localStorageService.decrypt((localStorage.getItem('M') || '')))
            this.data = _.cloneDeep(menu);
          }, 500)
    
          setTimeout(() => {
            if (this.data.length <= 0) {
              let menu = JSON.parse(this.localStorageService.decrypt((localStorage.getItem('M') || '')))
              this.data = _.cloneDeep(menu);
    
            }
          }, 3000)
    
        } else {
          this.data = _.cloneDeep(JSON.parse(this.localStorageService.decrypt((item))))
        } */


    // this.sideBarService.getAllModules(session?.id ?? 0).pipe(take(1)).subscribe({
    //   next: (value: ModuleBaseResponse) => {
    //     setTimeout(() => {
    //       this.data = _.cloneDeep(value.menu);
    //       localStorage.setItem('M', this.localStorageService.encrypt(JSON.stringify(value.menu)))

    //     }, 400);

    //   }
    // })
    setTimeout(() => {

      this.ready = true;
    }, 500);


    /*   this.localStorageService.menuReady$.pipe(takeUntil(this.theEnd$)).subscribe((val: boolean) => {
        if (val) {
          let menu = JSON.parse(this.localStorageService.decrypt((localStorage.getItem('M') || '')))
          this.data = _.cloneDeep(menu);
        }
      }); */
  }

  ngAfterViewInit(): void {

    this.logoPath = this.sideBarService.setImage()

    this.globalService.imageChange.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (value: string) => {
        this.logoPath = value;
      }
    })
  }


  onNodeSelected(event: any) {
    this.displayOptions = false;
    if (this.browserDetector.detectBrowserMobile()) {
      this.globalService.closeSidebar.next();
    }
  }

  settings() {
    this.onNodeSelected('');
    this.router.navigate(['home/settings']);
  }


  /* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
  showButton() {
    this.displayOptions = !this.displayOptions;
  }

  logout() {
    let tokens = this.localStorageService.getTokens();
    if (tokens == null) {
      console.log('user already logged out');
      this.router.navigate(['/login/']);
      return;
    }
    this.loginService.disconnectCurrentSession(tokens.refreshToken).subscribe({
      next: (d: any) => {
        this.localStorageService.clearSession();
        console.log('log out completed');
        localStorage.setItem('refresh', 'true');
        this.router.navigate(['/login/']);

      },
      error: (e: any) => {

        //this.store.removeReducer('modules');

        //this.store.removeReducer('menu');
        this.localStorageService.clearSession();
        console.log('Partial logout executed');
        this.router.navigate(['/login/']);
      },
    });
    // location.reload();

  }

  navigateTo(linkPart: string) {
    this.router.navigate([`${linkPart}`]);
  }



}
